import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import { StoreExt } from '@utils/reactExt'

import { coupons } from '@services/api'

export class couponTypesStore extends StoreExt {
    @observable loading = false
    @observable list = []
    @observable editCouponType = {}
    @observable filters = {}
    @observable errors = {}

    @action
    getList = async () => {
        this.loading = true
        coupons
            .getCouponTypes({ ...this.filters })
            .then(res => {
                runInAction(() => {
                    this.list = res.data
                    this.errors = {}
                })
            })
            .catch(e => {
                runInAction(() => {
                    this.list = []
                    this.errors = { serverError: 'קיימת שגיאה בשרת' }
                })
            })
        this.loading = false
    }

    @action
    submitCouponType = async () => {
        if ('id' in this.editCouponType) {
            try {
                return await coupons.updateCouponType(this.editCouponType)
            } catch (error) {
                return { error }
            }
        } else {
            try {
                return await coupons.addCouponType(this.editCouponType)
            } catch (error) {
                return { error }
            }
        }
    }

    @action
    deleteCouponType = async () => {
        try {
            return await coupons.deleteCouponType(this.editCouponType['id'])
        } catch (error) {
            return error
        }
    }

    @action
    changeEditValue = (name, value) => {
        console.log(name, value)
        const prevCouponType = { ...this.editCouponType }
        if (!value && name in prevCouponType) {
            delete prevCouponType[name]
            this.editCouponType = prevCouponType
        } else {
            this.editCouponType[name] = value
        }
    }

    @action
    setEditCouponType = couponType => {
        this.editCouponType = { ...couponType }
    }

    @action
    resetEditCouponType = () => {
        this.editCouponType = {}
    }

    @action
    addFilter = (name, value) => {
        const newFilters = { ...this.filters }
        if (name in newFilters && !value) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.filters = newFilters
        })
    }

    @action
    resetFilters = (filters = []) => {
        if (filters.length > 0) {
            const newFilters = { ...this.filters }
            filters.forEach(filter => filter in newFilters && delete newFilters[filter])
            runInAction(() => {
                this.filters = newFilters
            })
        } else {
            this.filters = {}
        }
    }

    @action
    resetList = () => {
        this.list = []
    }
}

export default remotedev(new couponTypesStore())
